import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import {normalizeStyles, containerStyles, moduleSpacingStyles} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement("webs-stats")
export class Stats extends LitElement {
  static styles = [
    moduleSpacingStyles,
    normalizeStyles,
    containerStyles,
    css`
      .wrapper {
        background-color: var(--color-light-grey);
        padding: 3.2rem 0;
      }

      .m-stats ::slotted(*) {
        margin-bottom: 1.6rem;
      }

      .m-stats .container {
        margin-bottom: -1.6rem;
      }

      .bg_primary {
        background-color: var(--color-primary);
      }

      .bg_secondary {
        background-color: var(--color-secondary);
      }

      .bg_dark-grey{
        background-color: var(--color-dark-grey);
        color: var(--color-white);
      }
    `,
  ];

  @property()
  id: string;

  @property()
  background: string;

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-stats ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="wrapper">
          <div class="container">
            <webs-grid-row justify="center" id="cards">
                <slot></slot>
            </webs-grid-row>
          </div>
        </div>
      </section>
    `;
  }
}
